import React from "react";
import { FormGroup, Label, Button, Input, Col, Row } from "reactstrap";
import "./Invitation-Inputs.css";
const ResponsiveInviteRespondantsModal = (props) => {

    return (
        <div className='Responsive-InviteRespondants-Modal'>
            <Row form style={{ justifyContent: "space-around" }}>
                {props.inputFields.map((modalInput, index) => {
                    return (
                        <div key={index}>
                            {modalInput.inputType === "select" ? (
                                <Input
                                    style={{ display: 'flex' }}
                                    type={modalInput.inputType}
                                    name={modalInput.name}
                                    id={`select-${index}`}
                                    className="select-input"
                                    defaultValue="Select"
                                >
                                    <option value="Select" disabled>
                                        Select
                                    </option>
                                    {Object.values(props.dropDownOptions).map(
                                        (dropDown, index) => {
                                            return <option key={index} value={dropDown.assessor_group__assessor_name}>{dropDown.assessor_group__assessor_name}</option>;
                                        }
                                    )}
                                </Input>
                            ) : (
                                <React.Fragment>
                                    <Input
                                        style={{ display: 'flex' }}
                                        placeholder="Enter an email Id"
                                        type={modalInput.inputType}
                                        name={modalInput.name}
                                        id={`email-${index}`}
                                        className="email-input"
                                        onChange={(e) =>
                                            props.handleMultipleEmail(e.target.value, index)
                                        }
                                    />
                                    <span id={`error-${index}`}></span>
                                </React.Fragment>
                            )}
                        </div>
                    );
                })}
            </Row>
            <div className="form-button-wrapper">
                <FormGroup check>
                    {props.isDisabled === true ? (
                        <Label check className="disabled-button">
                            <Input
                                type="checkbox"
                                defaultChecked={props.isChecked}
                                style={{ cursor: "not-allowed" }}
                                disabled
                            />
                            ADD ANOTHER
                        </Label>
                    ) : (
                        <Label check>
                            <Input
                                type="checkbox"
                                defaultChecked={props.isChecked}
                                onChange={props.handleInputFields}
                            />
                            ADD ANOTHER
                        </Label>
                    )}
                </FormGroup>
                {props.isDisabled === true ? (
                    <Button type="submit" className="disabled-button" value="submit">
                        Submit
                    </Button>
                ) : (
                    <Button
                        className="active-button"
                        onClick={props.handleInviteModalSubmit}
                    >
                        Submit
                    </Button>
                )}
            </div>
        </div>
    );
};

export default ResponsiveInviteRespondantsModal;



// WEBPACK FOOTER //
// ./src/new/Components/CompletedAssessment/Invite-Respondants-Modal/Responsive/Invitation-Inputs.jsx